/** Shared primitives for the ATLAS Automation Studio. */
export const Sel = ({ value, onChange, children, testId, className = "" }) => (
  <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className={`h-8 rounded-md border border-slate-200 bg-white px-2 text-[12px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-sky-200 ${className}`}>
    {children}
  </select>
);

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1">
    <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    {children}
    {hint && <span className="block text-[10px] text-slate-400">{hint}</span>}
  </label>
);

export const KW = ({ k, tone }) => <span className={`font-mono text-[10px] font-bold uppercase tracking-wider ${tone}`}>{k}</span>;
export const TONE = { WHEN: "text-sky-700", IF: "text-amber-700", THEN: "text-emerald-700", WAIT: "text-violet-700", ESCALATE: "text-rose-700", ELSE: "text-slate-500" };

export const RUN_CLS = {
  DONE: "bg-emerald-50 text-emerald-700 border-emerald-200", WAITING: "bg-violet-50 text-violet-700 border-violet-200", RUNNING: "bg-sky-50 text-sky-700 border-sky-200",
  FAILED: "bg-rose-50 text-rose-700 border-rose-200", CANCELLED: "bg-slate-100 text-slate-600 border-slate-200", SKIPPED: "bg-slate-50 text-slate-500 border-slate-200", NO_MATCH: "bg-slate-50 text-slate-500 border-slate-200",
};
export const PRIO_CLS = { critical: "bg-rose-50 text-rose-700 border-rose-200", high: "bg-amber-50 text-amber-700 border-amber-200", medium: "bg-sky-50 text-sky-700 border-sky-200", low: "bg-slate-50 text-slate-600 border-slate-200" };

export const Pill = ({ children, cls, testId }) => <span className={`inline-block rounded border px-1.5 py-0.5 font-mono text-[10px] uppercase ${cls || ""}`} data-testid={testId}>{children}</span>;

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const inr = (v) => (v == null || v === "" ? "" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`);

export const emptyRule = () => ({ name: "", description: "", when: { kind: "event", event: "payment.proof_received" }, conditions: [], steps: [{ type: "create_task", params: { title: "", action: "Open", to: "finance", priority: "HIGH", due_in_hours: 24, close_on: [] } }], else_steps: [], owner_email: "", priority: "medium", enabled: false, cooldown_hours: 24 });

export const stepLabel = (s, cat) => {
  const p = s.params || {};
  if (s.type === "wait") return `WAIT ${p.hours || "?"}h${p.unless?.length ? ` unless ${p.unless.join(" / ")}` : ""}`;
  if (s.type === "escalate") return `ESCALATE → ${cat?.targets?.[p.to] || p.to || "management"}`;
  if (s.type === "send_communication") return `Send ${cat?.intents?.[p.intent]?.label || p.intent}${p.channel ? ` via ${p.channel}` : " (router picks channel)"}`;
  if (s.type === "create_task") return `Task "${p.title || "…"}" → ${cat?.targets?.[p.to] || p.to || "owner"}`;
  if (s.type === "notify") return `Notify ${cat?.targets?.[p.to] || p.to || "owner"}`;
  if (s.type === "request_approval") return `Approval → ${cat?.targets?.[p.to] || p.to || "management"}`;
  if (s.type === "emit_event") return `Emit ${p.event}`;
  return s.type;
};
